// 9fbef606107a605d69c0edbcd8029e5d
import BAGPAGE_CONSTANTS from '../BagPage.constants';

export const setCouponMergeError = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_COUPON_MERGE_ERROR,
    payload,
  };
};

export const setMaxItemError = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_MAX_ITEM_ERROR,
    payload,
  };
};
export const setOOSError = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_OOS_ERROR,
    payload,
  };
};
export const setVMPItemError = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_VMP_ERROR,
    payload,
  };
};

export const setBackPackDeletedError = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_BACKPACK_DELETED_ERROR,
    payload,
  };
};

export const setMaxItemErrorDisplayed = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_MAX_ITEM_ERROR_DISPLAYED,
    payload,
  };
};
